import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './controlePatioForm';
import FormEntrada from './controlePatioEntradaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';
import Cookies from 'js-cookie';

import { 
	setModoTela, setFiltro, initForm, salvarEntrada, salvarSaida, excluir, getLista,
	getListaMotorista, getListaPlaca, getListaLogs
} from './controlePatioActions';
import { 
	getLista as getListaSetor
} from '../setor/setorActions';

const columns = [{
    field: 'cavalo',
    type: 'text'
}];

class ControlePatioStatus extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'cavalo',
			direction: 'asc'
		},
	}

	constructor(props) {
		super(props)

		this.scrollRef = React.createRef();
		this.scrollInterval = null;
		this.timeoutDirection = null;
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaSetor();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
		}, 30000);
	}

	componentDidUpdate() {
		
		if (!this.scrollInterval) {
			this.startAutoScroll()
		}
		
	}

	componentWillUnmount() {
		clearInterval(this.scrollInterval);
		clearTimeout(this.timeoutDirection);
		clearInterval(this.idIntervalAtualizacao);
	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'entrada' ? (
						<FormEntrada onSubmit={(registro) => this.props.salvarEntrada(registro)} />
					) : null}
					{this.props.modoTela == 'saida' ? (
						<Form onSubmit={(registro) => this.props.salvarSaida(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista;

		return listaFiltrada;
	}

	startAutoScroll() {

		const container = this.scrollRef ? this.scrollRef.current : null;
		if (!container) return;

		if (container.scrollHeight <= container.clientHeight) return;

		let direction = 1;
		const speed = 0.5;
		const delayAtEnd = 10000;

		this.timeoutDirection = null;

		this.scrollInterval = setInterval(() => {

			container.scrollTop += speed * direction;

			const chegouFim = (container.scrollTop + container.clientHeight) >= container.scrollHeight - 1;
			const chegouTopo = container.scrollTop <= 0;

			// fim descendo
			if (chegouFim && direction === 1 && !this.timeoutDirection) {

				this.timeoutDirection = setTimeout(() => {
					direction = -1;
					this.timeoutDirection = null;
				}, delayAtEnd);
			}

			// topo subindo
			if (chegouTopo && direction === -1 && !this.timeoutDirection) {

				this.timeoutDirection = setTimeout(() => {
					direction = 1;
					this.timeoutDirection = null;
				}, delayAtEnd);
			}

		}, 20);
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		const heightTela = `${window.innerHeight - 64}px`;

		return (
			<div 
				ref={this.scrollRef}
				style={{
					height: heightTela,
					paddingLeft: 20,
					paddingRight: 4,
					paddingTop: 20,
					backgroundColor: '#1F3066',
					overflowY: 'auto',
					overflowX: 'hidden',
					scrollbarWidth: 'thin'
				}}>
				<Row style={{}}>
					{lista.filter(item => item.id_status == 3).map((item, i) => (
						<Grid cols='12 6 4 3' key={item.id}
							style={{ padding: 0, marginBottom: 16 }}>
							<div
								className='controle-patio-card-hover'
								style={{
									backgroundColor: '#fff',
									borderRadius: 14,
									padding: 14,
									boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
									transition: 'all 0.2s ease',
									cursor: 'pointer',
									display: 'flex',
									flexDirection: 'column',
									height: 200
								}}
								onMouseEnter={e => {
									e.currentTarget.style.transform = 'translateY(-3px)';
									e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
								}}
								onMouseLeave={e => {
									e.currentTarget.style.transform = 'translateY(0)';
									e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
								}}
								onClick={() => { }}
							>

								{/* HEADER */}
								<div style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									marginBottom: 8
								}}>
									<div style={{
										fontSize: 18,
										fontWeight: 'bold',
										color: '#1F3066'
									}}>
										{item.cavalo}
									</div>

									<div style={{ fontSize: 12, color: '#666' }}>
										{item.carreta1}
										{item.carreta1 && item.carreta2 ? ' | ' : ''}
										{item.carreta2}
									</div>
								</div>

								{/* MOTORISTA */}
								<div style={{ fontSize: 13, marginBottom: 6 }}>
									<i class='fas fa-user' style={{ marginRight: 6 }} />
									<b>{item.nome_motorista}</b>
								</div>

								{/* DATAS */}
								<div style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									marginBottom: 2
								}}>
									<div style={{
										fontSize: 14,
										color: item.atraso == 'atrasado' ? '#b80300' : '#333',
										
										fontWeight: 'bold'
									}}>
										<i class='fas fa-calendar-check' style={{ marginRight: 6 }} />
										Prev: {DateFormat.formatarDataHoraSqlParaTela(item.datahora_previsao_saida)}
									</div>
								</div>
								{/*TEMPO LIBERADO */}
								{item.minutos_liberado_setores &&
								<div style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									marginBottom: 2
								}}>
									<div style={{ fontSize: 11, fontWeight: 'bold', color: '#555' }}>
										<i class='fas fa-clock' style={{ marginRight: 6 }} />
										Liberado há: {DateFormat.formatarMinutosParaTempo(item.minutos_liberado_setores)}
									</div>
								</div>}
								
								{/* INFO EXTRA */}
								<div style={{ fontSize: 11, color: '#555', marginBottom: 2 }}>
									<b>Cliente:</b> {item.cliente_saida}
								</div>
								{item.rumo_saida == 'RS' &&
								<div style={{  fontSize: 11, color: '#555', marginBottom: 2 }}>
									<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Fronteira:</b> {item.fronteira_saida}</div>
								</div>}
								{item.rumo_saida != 'RS' &&
								<div style={{  fontSize: 11, color: '#555', marginBottom: 2 }}>
									<div style={{ marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}><b>Destino:</b> {item.destino_saida}</div>
								</div>}

								{item.lote_crt_saida &&
								<div>
									<div
										style={{
											display: 'inline-flex',
											alignItems: 'center',
											backgroundColor: '#1F3066',
											color: '#ffffff',
											paddingLeft: 4,
											paddingRight: 4,
											paddingTop: 2,
											paddingBottom: 2,
											marginRight: 2,
											marginTop: 2,
											marginBottom: 2,
											borderRadius: 2,
											fontSize: 11,
											fontStyle: 'normal',
											marginTop: 2
										}}
										title={item.lote_crt_saida}>
										<i class='fas fa-boxes' style={{ marginRight: 4 }}></i>
										Lote ({item.lote_crt_saida})
									</div>
								</div>}

								{/* SETORES */}
								<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
									{item.listaPendenciaMotorista.map(ficha => {
										let cor = null;
										if (ficha.obrigatoria) {
											cor = '#949191';
										} else {
											cor = '#949191';
										}

										return (
											<div key={ficha.id_setor}
												style={{
													backgroundColor: cor,
													color: '#ffffff',
													paddingLeft: 4,
													paddingRight: 4,
													marginRight: 2,
													marginTop: 1,
													marginBottom: 1,
													borderRadius: 2,
													fontWeight: 'bold',
													fontSize: 12
												}}
												title={ficha.nome_setor}>
												{ficha.abreviacao_setor || ficha.nome_setor}
											</div>
										);
									})}
								</div>
							</div>
						</Grid>
					))}
				</Row>
			</div>
		);
	}

	getTextLabelRegistros(tamanho) {
		if (tamanho == 0) {
			return 'Nenhum registro';
		} else if (tamanho == 1) {
			return '1 registro';
		} else {
			return `${tamanho} registros`;
		}
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.controlePatio.aguardando,
	modoTela: state.controlePatio.modoTela,
	lista: state.controlePatio.lista,
	filtro: state.controlePatio.filtro,
	listaStatus: state.controlePatio.listaStatus,
	listaRumo: state.controlePatio.listaRumo,
	listaAtraso: state.controlePatio.listaAtraso
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvarEntrada, salvarSaida, excluir, getLista,
	getListaMotorista, getListaPlaca, getListaSetor, getListaLogs
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControlePatioStatus);
